import React, { useEffect, useState } from 'react'
import TagCloud from 'TagCloud'

const WordCloud = () => {
  const [isLoading, setLoad] = useState(true)

  const container = '.content'
  const texts = [
    'Solana',
    'Rust',
    'Solidity',
    'Web3.js',
    'React',
    'Vue.js',
    'mongoDB',
    'Express',
    'Angular.js',
    'Laravel',
    'NodeJS',
    'HTML5',
    'CSS3',
    'LESS/SCSS',
    'ES5/ES6',
    'JS',
    'TS',
    'MySQl',
    'C++',
    'C',
    'Git',
  ]
  const options = {
    radius: 300,
    // animation speed
    // slow, normal, fast
    maxSpeed: 'normal',
    initSpeed: 'normal',
    // 0 = top
    // 90 = left
    // 135 = right-bottom
    direction: 155,
    // interact with cursor move on mouse out
    keep: true,
  }
  //   to render wordcloud each time the page is reloaded
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (isLoading) {
      TagCloud(container, texts, options)
      console.log('i fire once')
      setLoad(false)
    }
  })

  return (
    <div className="main">
      <span className="content"></span>
    </div>
  )
}

export default WordCloud
